<template>
    
    <ul style=" list-style-type: none;padding: 0;">
        <router-link to="/panier"> <li class="m-3 text-secondary">Panier</li></router-link>
        <router-link to="/espace-client/commandes"><li class="m-3 text-secondary">Mes commandes</li></router-link>

        <router-link to="/espace-client/wishlist"> <li class="m-3 text-secondary">Wishlist</li></router-link>

        <router-link to="/espace-client"><li class="m-3 text-secondary">Mon compte</li></router-link>
    </ul>

</template>

<script>
export default ({
    name: "footer-Shop"
})
</script>


